// extracted by mini-css-extract-plugin
export default {"productTypes":"productTypes_productTypes__OMP3Y"};